import { render, staticRenderFns } from "./folders-ports-countries-options-details.vue?vue&type=template&id=469e8b5c&scoped=true"
import script from "./folders-ports-countries-options-details.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries-options-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469e8b5c",
  null
  
)

export default component.exports